var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-bar"},[_c('div',{staticClass:"risk-indicator",style:(_vm.indicatorStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }